import React from 'react';
export function IncludesSection() {
  const tomes = [{
    emoji: '🌱',
    title: 'Fundamentos',
    desc: 'Empieza bien desde el inicio'
  }, {
    emoji: '🌿',
    title: 'Plantación',
    desc: 'Qué plantar y cómo hacerlo'
  }, {
    emoji: '🌼',
    title: 'Cuidado',
    desc: 'Mantén tus plantas vivas'
  }, {
    emoji: '🐛',
    title: 'Plagas',
    desc: 'Protección natural'
  }, {
    emoji: '🏡',
    title: 'Espacios pequeños',
    desc: 'Ideal para departamentos'
  }, {
    emoji: '📋',
    title: 'Organización',
    desc: 'Mantén tu huerta en el tiempo'
  }];
  return <section className="relative bg-white py-10 px-4 sm:px-6 lg:px-8" data-id="element-61">
      <div className="max-w-6xl mx-auto" data-id="element-62">
        <h2 className="font-serif text-3xl sm:text-4xl font-black text-center text-[#1A1A1A] mb-6" data-id="element-63">
          📘 ¿Qué incluye?
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-4" data-id="element-64">
          {tomes.map((tome, index) => <div key={index} className="bg-neutral-bg rounded-2xl p-4 text-center shadow-sm hover:shadow-lg transition-all duration-300 border border-neutral-beige group" data-id="element-65">
              <div className="w-12 h-12 mx-auto bg-white rounded-full flex items-center justify-center text-2xl mb-3 shadow-sm group-hover:scale-110 transition-transform duration-300" data-id="element-66">
                {tome.emoji}
              </div>
              <h3 className="text-[10px] font-black text-garden-medium uppercase tracking-widest mb-1" data-id="element-67">
                Tomo {index + 1}
              </h3>
              <p className="text-sm font-black text-[#1A1A1A] mb-1 leading-tight" data-id="element-68">
                {tome.title}
              </p>
              <p className="text-xs text-gray-600 font-medium leading-snug" data-id="element-69">
                {tome.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}